<template>
    <v-container
      fluid>
        <v-row
            align="center"
            justify="center"
            class="job-links pa-0"
        >
            <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
            >
                <v-skeleton-loader v-if="loading"
                    v-bind="attrs"
                    type="article"
                    tile
                ></v-skeleton-loader>
                <v-card
                    tile
                    v-else
                    color="#002d56"
                >
                    <v-card-title class="white--text primary">
                        <span class="text-uppercase">{{ 'Job# ' + form.job_no }}</span>
                        <v-spacer></v-spacer>
                        <v-chip
                            color="green"
                            text-color="white"
                            v-if="form.status == 'completed'"
                        >
                            Completed
                        </v-chip>
                        <v-chip
                            color="white"
                            text-color="primary"
                            v-else-if="form.status == 'active'"
                        >
                            Active
                        </v-chip>
                        <v-chip
                            color="purple"
                            text-color="white"
                            v-else-if="form.status == 'archived'"
                        >
                            Archived
                        </v-chip>
                        <v-chip
                            color="red"
                            text-color="white"
                            v-else-if="form.status == 'cancelled'"
                        >
                            Cancelled
                        </v-chip>                        
                    </v-card-title>

                    <v-card-actions class="accent">
                        <v-btn text class="white accent--text" tile small @click="toggleJob">
                            Job Details
                        </v-btn>
                        <v-btn text class="white accent--text" tile small :to="`/job/details/${id}`">
                            Edit Job
                        </v-btn>
                        <v-btn text class="white accent--text" tile small @click="togglePayments">
                            Payments
                        </v-btn>
                        <!--<v-btn text class="white accent--text" tile small @click="getContract" :loading="loadingContract" v-if="form.envelope_id">
                            Download Contract
                        </v-btn>
                        <v-btn text class="white accent--text" tile small @click="sendContract" :loading="loadingContract">
                            Send Contract
                        </v-btn>-->
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            @click="showjob = !showjob"
                        >
                            <v-icon class="white--text">{{ showjob ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-btn>
                    </v-card-actions>

                    <v-card-title class="white--text primary pa-0" v-if="showpayments">
                        <div id="payment-info">
                            <div class="payment-block">Contract {{ form.amount | currency }}</div>
                            <div class="payment-block" style="background-color: #1e8bf7 !important;">CO ${{ form.change_total }}</div>
                            <div class="payment-block full-width accent white--text">Job Total {{ '$' +  form.new_total }}</div>
                            <div class="payment-block green white--text">Total Paid {{ '$' + form.total_paid }}</div>
                            <div class="payment-block red white--text">Balance {{ '$' + form.payments_balance }}</div>
                        </div>                  
                    </v-card-title>

                    <v-expand-transition>
                        <div v-show="showjob">
                            <v-divider></v-divider>

                            <v-card-text>
                                <v-simple-table tile class="simple mb-4">
                                    <template v-slot:default>
                                        <tbody>
                                            <tr>
                                                <td>Contract Amount</td>
                                                <td>{{ form.amount | currency }}</td>
                                            </tr>
                                            <tr>
                                                <td>Contract Date</td>
                                                <td>{{ formatDate(form.date) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Start Date</td>
                                                <td>{{ formatDate(form.start_date) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Pool Size</td>
                                                <td>{{ computedSize }}</td>
                                            </tr>
                                            <tr v-if="form.other_size"> 
                                                <td>Other Size</td>
                                                <td>{{ form.other_size }}</td>
                                            </tr>
                                            <tr>
                                                <td>Pool Shape</td>
                                                <td>{{ computedShape }}</td>
                                            </tr>
                                            <tr v-if="form.type_image">
                                                <td>Pool Shape Type</td>
                                                <td>
                                                    <v-img
                                                        max-width="300"
                                                        :src="form.type_image"
                                                    ></v-img>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Pool Addons</td>
                                                <td>
                                                    <span
                                                    class="popt"
                                                    v-for="(opt, index) in form.pooloptions"
                                                    :key="index"
                                                    >
                                                        {{ getOptionTitle(opt) }}
                                                    </span>                                                  
                                                </td>
                                            </tr>
                                            <tr v-if="form.noofled">
                                                <td>No Of LED's</td>
                                                <td>{{ form.noofled }}</td>
                                            </tr>
                                            <tr v-if="form.noofbubblers">
                                                <td>No of Bubblers</td>
                                                <td>{{ form.noofbubblers }}</td>
                                            </tr>
                                            <tr v-if="form.deck_color">
                                                <td>Deck Color</td>
                                                <td>{{ form.deck_color }}</td>
                                            </tr>
                                            <tr v-if="form.waterfall_color">
                                                <td>Waterfall Color</td>
                                                <td>{{ form.waterfall_color }}</td>
                                            </tr>
                                            <tr v-if="form.extra_concrete">
                                                <td>Extra Concrete</td>
                                                <td>{{ form.extra_concrete }}</td>
                                            </tr>
                                            <tr v-if="form.retaining_wall">
                                                <td>Retaining Wall</td>
                                                <td>{{ form.retaining_wall }}</td>
                                            </tr>
                                            <tr v-if="form.retaining_wall_data">
                                                <td>Retaining Wall Data</td>
                                                <td>{{ form.retaining_wall_data }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>

                                <vue-picture-swipe :items="imgitems" @update-images="getJob"></vue-picture-swipe>
                            </v-card-text>
                        </div>
                    </v-expand-transition>
                    <v-expand-transition>
                        <div v-show="showpayments">
                            <v-divider></v-divider>
                            <v-card-text>
                                <Payments :job="id" :obj="form" @update-job="getJob"/>
                                <ChangeOrders :job="id" :obj="form" @update-job="getJob"/>
                                <Lenders :job="id" :obj="form"/>
                            </v-card-text>
                        </div>
                    </v-expand-transition>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
            >
                <v-skeleton-loader v-if="loading"
                    v-bind="attrs"
                    type="article"
                    tile
                ></v-skeleton-loader>
                <v-card
                    tile
                    v-else
                    color="primary"
                >
                    <v-card-title class="white--text text-uppercase">
                        {{ form.customer.object.first_name + ' ' + form.customer.object.last_name }}
                    </v-card-title>

                    <v-card-subtitle class="white--text">
                        <v-btn text @click="showmap = !showmap" class="text-capitalize pa-0 white--text">
                            <v-icon dark class="mr-1">mdi-pin</v-icon>{{ form.customer.object.street_address + ' ' + form.customer.object.city + ' ' + form.customer.object.state + ' ' + form.customer.object.zip }}
                        </v-btn>
                    </v-card-subtitle>

                    <v-card-actions class="accent">
                        <v-btn text class="white accent--text" tile small :to="{ name:'Customer', params:{id: form.customer.value, redirect: 'JobMain', job: id} }">
                            Open Customer
                        </v-btn>
                        <v-spacer></v-spacer>

                        <v-btn icon dark :href="`tel:${form.customer.object.phone}`">
                            <v-icon>mdi-phone</v-icon>
                        </v-btn>

                        <v-btn icon dark :href="`mailto:${form.customer.object.email}`">
                            <v-icon>mdi-email-open</v-icon>
                        </v-btn>

                        <v-btn icon dark :href="form.customer.object.google_link" target="_blank">
                            <v-icon>mdi-directions</v-icon>
                        </v-btn>
        
                        <v-btn icon dark :to="`/job/chat/${id}`">
                            <v-icon>mdi-message</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <v-card
                    flat
                    loader-height="10"
                    tile
                    min-width="100%"
                    v-if="showmap"
                >
                    <v-row
                        align="center"
                        justify="center"
                        class="pa-0 ma-0"
                    >
                        <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                            class="pa-0 ma-0"
                        >
                        <mapbox
                            access-token="pk.eyJ1IjoiYmlnY2l0eSIsImEiOiJjazhpb2c0cGgwNnh0M21ud2s3YzY4MGpjIn0.0AYL_R9U7wU8WQck6doT-w"
                            :map-options="{
                                style: 'mapbox://styles/mapbox/streets-v9',
                                center: mapMarker,
                                zoom: 10,
                            }"
                            @map-load="loaded"
                            @map-click:points="clicked"
                            @map-mouseenter:points="mouseEntered"
                            @map-mouseleave:points="mouseLeft"
                        />
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
            >
                <v-skeleton-loader v-if="loading"
                    v-bind="attrs"
                    type="article"
                    tile
                ></v-skeleton-loader>
                <v-card
                    tile
                    v-else
                    color="#002d56"
                >
                    <v-card-title class="white--text primary">
                        <span class="text-uppercase">Assignees</span>
                        <v-spacer></v-spacer>
                        <v-chip
                            color="accent"
                            text-color="white"
                            v-if="form.users !== null"
                        >
                            {{ Object.keys(form.users).length }} 
                        </v-chip>                   
                    </v-card-title>

                    <v-card-actions class="accent">
                        <v-btn text class="white accent--text" tile small :to="`/job/assignees/${id}`">
                            Edit Assignees
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            @click="showassign = !showassign"
                        >
                            <v-icon class="white--text">{{ showassign ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-btn>
                    </v-card-actions>

                    <v-expand-transition>
                        <div v-show="showassign">
                            <v-divider></v-divider>

                            <v-card-text>
                                <v-simple-table tile class="simple" v-if="form.users !== null">
                                    <template v-slot:default>
                                        <tbody>
                                            <tr>
                                                <td>Admin</td>
                                                <td>
                                                    {{ userName(form.users.admin) }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Foreman</td>
                                                <td>{{ userName(form.users.foreman) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Sales Person</td>
                                                <td>{{ userName(form.users.salesperson) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Service Technician</td>
                                                <td>{{ userName(form.users.technician) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Cleaner</td>
                                                <td>{{ userName(form.users.cleaner) }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card-text>
                        </div>
                    </v-expand-transition>
                </v-card>
            </v-col>
            <!--<v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
            >
                <v-skeleton-loader v-if="loading"
                    v-bind="attrs"
                    type="article"
                    tile
                ></v-skeleton-loader>
                <v-card
                    tile
                    v-else
                    color="#002d56"
                >
                    <v-card-title class="white--text primary">
                        <span class="text-uppercase">Issues</span>
                        <v-spacer></v-spacer>
                        <v-chip
                            color="accent"
                            text-color="white"
                            class="mr-1"
                        >
                            Pending: {{ form.issues_pending_count }}
                        </v-chip> 
                        <v-chip
                            color="orange"
                            text-color="white"
                        >
                            In Progress: {{ form.issues_ip_count }}
                        </v-chip>                   
                    </v-card-title>

                    <v-card-actions class="accent">
                        <v-btn text class="white accent--text" tile small :to="`/job/issue_tracker/${id}`">
                            Open Issue Tracker
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            @click="showissues = !showissues"
                        >
                            <v-icon class="white--text">{{ showissues ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-btn>
                    </v-card-actions>

                    <v-expand-transition>
                        <div v-show="showissues">
                            <v-divider></v-divider>

                            <v-card-text>
                                <v-data-table
                                    :headers="issues_headers"
                                    :items="form.issues.data"
                                    sort-by="model"
                                    class="elevation-1"
                                    hide-default-footer
                                    item-key="id"
                                >
                                    <template v-slot:no-data>
                                        <span>No Active or Pending Issues Found!</span>
                                    </template>
                                    <template v-slot:item.assignee="{ item }">
                                        <span>{{ getUsername(item.assignee) }}</span>
                                    </template>
                                    <template v-slot:item.status="{ item }">
                                        <v-chip
                                            color="green"
                                            text-color="white"
                                            v-if="item.status == 'resolved'"
                                        >
                                            Resolved
                                        </v-chip>
                                        <v-chip
                                            color="primary"
                                            text-color="white"
                                            v-else-if="item.status == 'pending'"
                                        >
                                            Pending
                                        </v-chip>
                                        <v-chip
                                            color="orange"
                                            text-color="white"
                                            v-else-if="item.status == 'in_progress'"
                                        >
                                            In Progress
                                        </v-chip>
                                        <v-chip
                                            color="red"
                                            text-color="white"
                                            v-else-if="item.status == 'cancelled'"
                                        >
                                            Cancelled
                                        </v-chip>
                                    </template>
                                    <template v-slot:item.deadline="{ item }">
                                        <span>{{ formatDate(item.deadline) }}</span>
                                    </template>
                                </v-data-table>

                                <div class="d-flex justify-center" v-if="Object.keys(form.issues.data).length">
                                    <v-btn
                                        color="primary mt-3"
                                        :to="`/job/issue_tracker/${id}`"
                                        tile
                                    >
                                        Show More
                                    </v-btn>
                                </div>
                            </v-card-text>
                        </div>
                    </v-expand-transition>
                </v-card>
            </v-col>-->
            <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
            >
                <v-skeleton-loader v-if="loading"
                    v-bind="attrs"
                    type="article"
                    tile
                ></v-skeleton-loader>
                <v-card
                    tile
                    v-else
                    color="#002d56"
                >
                    <v-card-title class="white--text primary">
                        <span class="text-uppercase">Punchlist</span>                  
                    </v-card-title>

                    <v-card-actions class="accent">
                        <v-btn text class="white accent--text" tile small :to="`/job/punch_list/${id}`">
                            Open Punchlist
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            @click="showpl = !showpl"
                        >
                            <v-icon class="white--text">{{ showpl ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-btn>
                    </v-card-actions>

                    <v-expand-transition>
                        <div v-show="showpl">
                            <v-divider></v-divider>

                            <v-card-text>
                                <v-simple-table tile class="simple">
                                    <template v-slot:default>
                                        <tbody>
                                            <tr v-for="(list, index) in form.punchlist" :key="`pt-${index}`">
                                                <td>{{ getCategoryName(index) }}</td>
                                                <td>
                                                    <v-chip
                                                        color="primary"
                                                        text-color="white"
                                                        class="mr-1"
                                                    >
                                                        {{ 'Pending: ' + getCategoryCount(index, 0) }}
                                                    </v-chip> 
                                                    <v-chip
                                                        color="green"
                                                        text-color="white"
                                                    >
                                                        {{ 'Completed: ' + getCategoryCount(index, 1) }}
                                                    </v-chip>   
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <div class="d-flex justify-center" v-if="Object.keys(form.punchlist).length">
                                    <v-btn
                                        color="primary mt-3"
                                        :to="`/job/punch_list/${id}`"
                                        tile
                                    >
                                        Show More
                                    </v-btn>
                                </div>
                            </v-card-text>
                        </div>
                    </v-expand-transition>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="4"
                lg="4"
                v-for="(module, index) in modules"
                :key="`mod-${index}`"
                class="pa-0"
            >
                <v-card
                    class="single-module"
                    light
                    outlined
                    color="#1565c0"
                    tile
                    :to="module.link + form.customer.object.id"
                    v-if="module.title == 'Customer'"
                >
                    <v-card-title class="pt-4 justify-center">    
                        <v-icon
                            large
                            color="white"
                        >
                            {{ module.icon }}
                        </v-icon>                         
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="subtitle-1 font-weight-bold white--text">{{ module.title }}</span>
                    </v-card-text>
                </v-card>
                <v-card
                    class="single-module"
                    light
                    outlined
                    color="#1565c0"
                    tile
                    :to="module.link + id"
                    v-else
                >
                    <v-card-title class="pt-4 justify-center">    
                        <v-icon
                            large
                            color="white"
                        >
                            {{ module.icon }}
                        </v-icon>                         
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="subtitle-1 font-weight-bold white--text">{{ module.title }}</span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import { mapGetters } from 'vuex'
    import Mapbox from 'mapbox-gl-vue'
    import PopupContent from '../../components/PopupContent.vue'      
    import mixin from '../../mixin/main.js' 
    import VuePictureSwipe from '../../components/Swipe/Swipe.vue'
    import Payments from '../../components/Jobs/Payments.vue' 
    import ChangeOrders from '../../components/Jobs/ChangeOrders.vue' 
    import Lenders from '../../components/Jobs/Financing.vue' 

    export default {
        mixins: [mixin],
        props: ['id'],
        data: () => ({
            loading: true,
            loadingContract: false,
            form: {
                customer: {
                    label: '',
                    value: '',
                    object: []
                },
                status: '',
                date: new Date().toISOString().substr(0, 10),
                amount: '',
                job_type: '',
                size: '',
                shape: '',
                pool_type: '',
                users: {
                    admin: '',
                    foreman: '',
                    salesperson: '',
                    technician: '',
                    cleaner: ''
                },
                pooloptions: [],
                liner_color: '',
                tile_selection: '',
                plaster: '',
                coping: '',
                deck: '',
                deck_color: '',
                border_color: '',
                waterfall_color: '',
                images: [],
                comments: [],
                type_image: ''     
            },
            showjob: false,
            showpayments: false,
            showassign: false,
            showissues: true,
            showpl: true,
            showmap: false,
            issues_headers: [
                {
                  text: 'Issue',
                  align: 'start',
                  sortable: false,
                  value: 'issue',
                },
                { text: 'Status', value: 'status', sortable: false },
                { text: 'Deadline', value: 'deadline', sortable: false },
                { text: 'Assignee', value: 'assignee', sortable: false },
                { text: 'Description', value: 'description', sortable: false },
            ],
            pl_headers: [
                {
                  text: 'Phase',
                  align: 'start',
                  sortable: false,
                  value: 'phase'
                },
                { text: 'Scheduled', value: 'scheduled', sortable: false },
                { text: 'Completed', value: 'completed', sortable: false },
                { text: 'Status', value: 'status', sortable: false },
                { text: 'Assignee', value: 'assignee', sortable: false },
            ],
            modules: [
                {
                    title: 'Phases',
                    icon: 'mdi-clipboard-list',
                    link: '/job/phase_list/'  
                },
                {
                    title: 'Custom Punchlist',
                    icon: 'mdi-checkbox-marked-outline',
                    link: '/job/custom_punch_list/'                    
                },
                {
                    title: 'Media',
                    icon: 'mdi-file-image',
                    link: '/job/media/'
                },
                {
                    title: 'Chat',
                    icon: 'mdi-message',
                    link: '/job/chat/' 
                },
                {
                    title: 'Equipment',
                    icon: 'mdi-cube',
                    link: '/job/equipment/' 
                },   
                {
                    title: 'Warranty',
                    icon: 'mdi-marker-check',
                    link: '/job/warranty/'  
                },
                {
                    title: 'Activity Log',
                    icon: 'mdi-swap-horizontal',
                    link: '/job/activities/'
                },                   
            ]
        }),
        created() {
            this.getJob()
        },
        mounted() {
            window.scrollTo(0,0)
        },
        components: {
            Mapbox,
            'vue-picture-swipe': VuePictureSwipe,
            Payments,
            ChangeOrders,
            Lenders
        },
        methods: {
            toggleJob() {
                this.showjob = !this.showjob
                this.showpayments = false
            },
            togglePayments() {
                this.showpayments = !this.showpayments
                this.showjob = false
            },
            getJob() {
                if(this.id) {
                    axios.get('crm/job/get?id=' + this.id)
                        .then((response) => {
                            this.loading = false
                            this.form = response.data
                            this.$nextTick()
                        })
                }
            },
            sendContract() {
                if(this.id) {
                    const reqdata = { id: this.id }
                    this.loadingContract = true

                    axios.post('crm/job/docusign', reqdata)
                        .then((response) => {
                            this.loadingContract = false
                            window.open(response.data.url,'_blank')
                            this.$nextTick()
                        })
                }
            },
            getContract() {
                if(this.id) {
                    const reqdata = { id: this.id }
                    this.loadingContract = true

                    axios.post('crm/job/docusigndoc', reqdata)
                        .then((response) => {
                            this.loadingContract = false
                            window.open(response.data.url,'_blank')
                            this.$nextTick()
                        })
                }
            },
            userName(id) {
                let user = this.users.filter(user => {
                    return user.id == id
                })

                if(user.length > 0) {
                    return user[0].name
                } else {
                    return ''
                }
            },
            loaded(map) {
                const images =  [
                    {url: 'https://crm.mrpoolal.com/img/activem.png', id: 'active'},
                    {url: 'https://crm.mrpoolal.com/img/completedm.png', id: 'completed'},
                ];

                Promise.all(
                    images.map(img => new Promise((resolve) => {
                        map.loadImage(img.url, function(error, res) {
                            map.addImage(img.id, res)
                            resolve()
                        })
                    }))
                )
                .then(() => {
                    map.addLayer({
                        id: 'points',
                        type: 'symbol',
                        source: {
                            type: 'geojson',
                            data: {
                                type: 'FeatureCollection',
                                features: [
                                    {
                                        type: 'Feature',
                                        geometry: {
                                        type: 'Point',
                                            coordinates: this.mapMarker,
                                        },
                                        properties: {
                                            title: this.form.customer.object.street_address + ' ' + this.form.customer.object.city,
                                            address: this.form.customer.object.street_address + ' ' + this.form.customer.object.city + ' ' + this.form.customer.object.state + ' ' + this.form.customer.object.zip,
                                            status: this.form.status
                                        },
                                    },
                                ],
                            },
                        },
                        layout: {
                            'text-field': ['get', 'title'],
                            'text-font': [
                                'Open Sans Semibold',
                                'Arial Unicode MS Bold'
                            ],
                            'text-offset': [0, 1.25],
                            'text-anchor': 'top',
                            'icon-image': ['get', 'status'],
                        },
                    })
                })
            },
            clicked(map, e) {
                if (e.features) {
                    const coordinates = e.features[0].geometry.coordinates.slice()

                    // Ensure that if the map is zoomed out such that multiple
                    // copies of the feature are visible, the popup appears
                    // over the copy being pointed to.
                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
                    }

                    new mapboxgl.Popup()
                    .setLngLat({ lng: coordinates[0], lat: coordinates[1] })
                    .setHTML('<div id="vue-popup-content"></div>')
                    .addTo(map)

                    new PopupContent({
                    propsData: { feature: e.features[0] },
                    }).$mount('#vue-popup-content')
                }
            },
            mouseEntered(map) {
                map.getCanvas().style.cursor = 'pointer'
            },
            mouseLeft(map) {
                map.getCanvas().style.cursor = ''
            },
            getCategoryName(index) {
                let phase = this.form.phases.filter(phase => {
                    return phase.id == index
                })

                if(phase.length > 0) {
                    return phase[0].title
                } else {
                    return ''
                }
            },
            getCategoryCount(index, status) {
             let pl = this.form.punchlist[index].filter(pli => {
                 return pli.status == status
             })

             return pl.length
            },
            getOptionTitle(opt) {
                let options = this.options.filter(op => {
                    return op.id == opt
                })
                
                if(options.length > 0) {
                    return options[0].title
                } else {
                    return ''
                }
            }
        },
        computed: {
            ...mapGetters({
                users: 'data/users',
                statuses: 'data/jobStatusArray',
                measurement_types: 'data/measurement_types',
                options: 'data/options',
                sizes: 'data/sizes',
                job_types: 'data/job_types',
                shapes: 'data/shapes',
                liner_color: 'data/liner_color'
            }),
            computedSize() {
                if(this.form.size) {
                    let sizearr = this.sizes.filter(s => {
                        return s.id == this.form.size
                    })

                    if(sizearr.length) {
                        return sizearr[0].title
                    } else {
                        return ''
                    }
                } else {
                    return ''
                }
            },
            computedShape() {
                if(this.form.shape) {
                    let shapearr = this.shapes.filter(s => {
                        return s.id == this.form.shape
                    })

                    if(shapearr.length) {
                        return shapearr[0].title
                    } else {
                        return ''
                    }
                } else {
                    return ''
                }
            },
            mapMarker(){
                return [JSON.parse(this.form.customer.object.coordinates).longitude, JSON.parse(this.form.customer.object.coordinates).latitude]
            },
            imgitems() {
                var arr = [];
            
                this.form.images.forEach(function(item) {
                    var meta = JSON.parse(item.image_meta);
                    var img = {}; 
                    img ["src"] = 'https://api.mrpoolal.com/img/crmjobs/'+item.image;
                    img ["thumbnail"] = 'https://api.mrpoolal.com/img/crmjobs/'+item.image+'?w=1400';
                    img ["w"] = meta.width; // you modify it's properties
                    img ["h"] = meta.height; // you modify it's properties
                    img ["id"] = item.id
                    arr.push(img); // you push it to the array
                });   

                return arr         
            }
        },
    }
</script>
<style lang="sass">
.v-content
    background: #001528

.job-links   
    .col-sm-12 
        padding: 12px 5px 0

.v-application 
    .headline
        font-family: 'Pyxel'!important
        font-size: 1.5em!important

    .stat
        min-height: auto
        padding: 7px 12px!important
        border-radius: 3px

        > div 
            padding: 0!important

.v-skeleton-loader__article
    background: #003a6f!important

.single-module 
    border: thin solid rgb(255 255 255 / 12%)!important

.repeater
    padding: 30px 20px
    background: #eee
    margin: 10px 0
    text-align: center
    border-radius: 5px

.filepond--root
    margin-bottom: 0

.filepond--drop-label
    &.filepond--drop-label 
        label
            font-family: 'Roboto'

.text--primary.comment-text 
    img
        max-width: 100%

.tiptap-vuetify-editor 
    img
        max-width: 100%

.tiptap-vuetify-image-upload-area-holder
    background-color: #003a6f
    height: 300px
    outline: 2px dashed #ffffff

svg.tiptap-vuetify-image-upload-area-holder__icon
    display: none!important

label.tiptap-vuetify-image-upload-area-holder 
    br
        display: none

.tiptap-vuetify-image-upload-area-holder 
    h3
        color: #fff

.v-application
    .v-dialog 
        .headline
            font-family: inherit!important
            text-transform: uppercase
            font-weight: 500
            font-size: 24px!important

        .v-card__actions
            background: #eee

            .v-btn
                width: 49%

.v-data-table
    &.simple
        tr
            &:nth-child(2n)
                background: #f7f7f7

            td
                &:first-child   
                    border-right: 1px solid #eee
                    font-weight: bold

.v-data-table
    .v-data-table-header-mobile
        display: none
    tr
        td
            &.v-data-table__mobile-row:nth-child(2n)
                background: #f7f7f7

            &.v-data-table__mobile-row
                padding-left: 0

                .v-data-table__mobile-row__header
                    line-height: 48px
                    width: 40%
                    padding-left: 16px
                    border-right: 1px solid #eee

    &.dark-last-row
        .v-data-table__mobile-table-row 
            td
                &:last-child 
                    background: #003a6f
                    padding: 5px

                    .v-data-table__mobile-row__header
                        display: none

                    .v-data-table__mobile-row__cell
                            width: 100%

.viewer-toolbar
    >ul
        >li
            border-radius: 0

            &.viewer-one-to-one, &.viewer-reset, &.viewer-play 
                display: none!important

.my-gallery 
    display: grid
    grid-template-columns: auto auto auto auto

    figure
        margin: 0

    img
        max-width: 100%
        vertical-align: top

.v-sheet--tile
    border-radius: 0!important

span.popt
    font-size: 12px
    display: inline-block
    background: #001528
    padding: 4px 5px
    margin: 1px
    line-height: 1em
    border-radius: 3px
    color: #fff

#payment-info 
    display: flex
    flex-wrap: wrap
    flex: 1

.payment-block
    font-size: 14px
    padding: 5px 15px
    width: 50%
    text-align: center

.payment-block
    &.full-width
        width: 100%!important
</style>